import React from 'react';
import { Testimonial } from './types';
import { CheckCircleIcon, StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm flex flex-col gap-4" data-id="element-1665">
      {/* Star Rating */}
      <div className="flex gap-0.5" data-id="element-1666">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-1667" />)}
      </div>

      {/* Testimonial content */}
      <p className="text-[#374151] leading-relaxed text-[15px]" data-id="element-1668">
        "{testimonial.content}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-3 pt-2 mt-auto border-t border-gray-100" data-id="element-1669">
        <div className="relative flex-shrink-0" data-id="element-1670">
          <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-100" data-id="element-1671" />
          {testimonial.verified && <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-[#3ab795] rounded-full flex items-center justify-center ring-2 ring-white" data-id="element-1672">
              <CheckCircleIcon className="w-2.5 h-2.5 text-white" strokeWidth={3} data-id="element-1673" />
            </div>}
        </div>
        <div className="min-w-0" data-id="element-1674">
          <h4 className="font-semibold text-sm text-[#1D1D1D] truncate" data-id="element-1675">
            {testimonial.name}
          </h4>
          <p className="text-xs text-gray-500 truncate" data-id="element-1676">
            {testimonial.role}
            {testimonial.company && `, ${testimonial.company}`}
          </p>
        </div>
        {testimonial.verified && <span className="ml-auto text-[10px] font-medium text-[#3ab795] bg-[#3ab795]/8 px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0" data-id="element-1677">
            Verified
          </span>}
      </div>
    </div>;
}